import React from 'react';
import {
    DetailDossierTitle,
    DetailDossierToolbar,
    useSelectedDossierContext,
} from '@europrocurement/l2d-modules';
import { prescripteursBasePath } from '../../../Prescripteurs/constants/paths';

/**
 * Composant header du détail d'un dossier.
 * Gère le chargement progressif des données (prescripteur, offre, client opéré)
 * et affiche un skeleton durant le chargement.
 */
const DetailDossierHeader: React.FunctionComponent = function () {
    const { dossier, siblings, refreshDossier, updateDossier } = useSelectedDossierContext();

    // URLs et données formatées
    const clientOpereSocieteDotComUrl = `https://www.societe.com/cgi-bin/fiche?rncs=${dossier?.clientOpereSiren}`;
    /** URL vers la page de détail du prescripteur */
    const prescripteurDetailUrl = `/${prescripteursBasePath}/liste/${dossier?.prescripteurId}`;
    /** Données du dossier formatées pour l'affichage */
    const formattedDossier = {
        statut: dossier.statutLibelle as string,
        societeRef: dossier.societeRef as string,
        statutId: dossier.statutId as number,
    };

    /** Données du prescripteur formatées pour l'affichage */
    const formattedPrescripteur = {
        id: dossier?.prescripteurId as number,
        raisonSociale: (dossier.prescripteurLibelle as string) || 'Pas de raison sociale',
        codeComptable: dossier.prescripteurCodeCompta || 'Pas de code comptable',
        urlToDetails: prescripteurDetailUrl,
    };
    /** Données de l'offre formatées pour l'affichage */
    const formattedOffre = {
        libelle: dossier.offreLibelle || 'Aucune offre',
    };

    /** Données du client opéré formatées pour l'affichage */
    const formattedClientOpere = {
        raisonSociale: dossier.clientOpereLibelle || 'Pas de raison sociale',
        siren: dossier.clientOpereSiren as string,
        urlToSocieteDotCom: clientOpereSocieteDotComUrl,
        id: dossier.clientOpereId as number,
    };

    const isMultiDossiers = siblings.length > 1;

    return (
        <>
            {/* Toolbar affichée dès que dossier et siblings sont disponibles */}
            <DetailDossierToolbar
                dossier={dossier}
                source="BACK"
                siblingDossiers={siblings}
                isMultiDossiers={isMultiDossiers}
            />

            {/* Title affiché seulement quand toutes les données sont prêtes */}
            <DetailDossierTitle
                dossier={formattedDossier}
                prescripteur={formattedPrescripteur}
                offre={formattedOffre}
                clientOpere={formattedClientOpere}
                color="primary"
                refreshDossier={refreshDossier}
                updateDossier={updateDossier}
                icon={isMultiDossiers ? 'folders' : 'folder'}
            />
        </>
    );
};

export default DetailDossierHeader;
